export default {
  email: 'Email',
  ssoRR: 'RussiaRunningSso',
};
